import { Link } from "react-router-dom";

export interface StudyBreadcrumbProps {
  subjectSlug: string;
  subjectName: string;
  activity?: string;
  semester?: number | null;
}

export function StudyBreadcrumb({
  subjectSlug,
  subjectName,
  activity,
  semester,
}: StudyBreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-muted-foreground mb-4 flex-wrap">
      <Link to="/student/study" className="hover:text-primary transition-colors">Study</Link>
      {semester ? (
        <>
          <span className="opacity-40">/</span>
          <Link to={`/student/study/semester/${semester}`} className="hover:text-primary transition-colors">
            Semester {semester}
          </Link>
        </>
      ) : null}
      <span className="opacity-40">/</span>
      {activity ? (
        <>
          <Link to={`/student/study/${subjectSlug}`} className="hover:text-primary transition-colors">{subjectName}</Link>
          <span className="opacity-40">/</span>
          <span className="text-foreground font-medium">{activity}</span>
        </>
      ) : (
        <span className="text-foreground font-medium">{subjectName}</span>
      )}
    </nav>
  );
}
